// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.CardPerson_box_card__0PWH1 {
  position: relative;
  flex-basis: 350px;
  flex-grow: 1;
  min-width: 360px;
  display: flex;
  justify-content: center;
}
@media (max-width: 840px) {
  .CardPerson_box_card__0PWH1 {
    min-width: auto;
  }
}
.CardPerson_box_card__0PWH1 .CardPerson_card__OlqtF {
  box-sizing: border-box;
  max-width: 360px;
}
@media (max-width: 840px) {
  .CardPerson_box_card__0PWH1 .CardPerson_card__OlqtF {
    width: 100%;
    max-width: 60%;
  }
}
.CardPerson_box_card__0PWH1 .CardPerson_card__OlqtF .CardPerson_box_frame__UMt6a {
  position: relative;
}
.CardPerson_box_card__0PWH1 .CardPerson_card__OlqtF .CardPerson_box_frame__UMt6a .CardPerson_decor__pekup {
  position: absolute;
  margin-inline: -10px;
}
@media (max-width: 560px) {
  .CardPerson_box_card__0PWH1 .CardPerson_card__OlqtF .CardPerson_box_frame__UMt6a .CardPerson_decor__pekup {
    width: 70px;
  }
}
@media (max-width: 470px) {
  .CardPerson_box_card__0PWH1 .CardPerson_card__OlqtF .CardPerson_box_frame__UMt6a .CardPerson_decor__pekup {
    width: 60px;
  }
}
@media (max-width: 390px) {
  .CardPerson_box_card__0PWH1 .CardPerson_card__OlqtF .CardPerson_box_frame__UMt6a .CardPerson_decor__pekup {
    width: 50px;
  }
}
.CardPerson_box_card__0PWH1 .CardPerson_card__OlqtF .CardPerson_box_frame__UMt6a .CardPerson_frame__ac11w {
  width: 100%;
  position: relative;
  z-index: 2;
}
.CardPerson_box_card__0PWH1 .CardPerson_card__OlqtF .CardPerson_box_frame__UMt6a .CardPerson_box_foto__v-4GQ {
  position: absolute;
  inset: 0;
  display: flex;
  align-items: flex-start;
  justify-content: center;
}
.CardPerson_box_card__0PWH1 .CardPerson_card__OlqtF .CardPerson_box_frame__UMt6a .CardPerson_box_foto__v-4GQ .CardPerson_foto__t51R7 {
  width: 85%;
  height: 80%;
  padding-top: 10%;
  object-fit: cover;
  object-position: center;
  z-index: 1;
}
.CardPerson_box_card__0PWH1 .CardPerson_card__OlqtF .CardPerson_box_frame__UMt6a .CardPerson_name__7pvhP {
  margin: 0;
  position: absolute;
  bottom: 10px;
  font-family: "Beer money";
  font-weight: 400;
  width: 85%;
  margin-bottom: 5%;
  min-height: 17%;
  font-size: 1.5rem;
  line-height: 1.5rem;
  z-index: 3;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
}
@media (max-width: 420px) {
  .CardPerson_box_card__0PWH1 .CardPerson_card__OlqtF .CardPerson_box_frame__UMt6a .CardPerson_name__7pvhP {
    bottom: 5px;
    font-size: 1.3rem;
    line-height: 1.3rem;
  }
}
.CardPerson_box_card__0PWH1 .CardPerson_card__OlqtF .CardPerson_box_frame__UMt6a .CardPerson_inst__fjNzT {
  position: absolute;
  top: 65%;
  right: 0;
  z-index: 4;
}
@media (max-width: 620px) {
  .CardPerson_box_card__0PWH1 .CardPerson_card__OlqtF .CardPerson_box_frame__UMt6a .CardPerson_inst__fjNzT {
    top: 60%;
    transform: scale(1.2);
  }
}
@media (max-width: 480px) {
  .CardPerson_box_card__0PWH1 .CardPerson_card__OlqtF .CardPerson_box_frame__UMt6a .CardPerson_inst__fjNzT {
    transform: scale(1);
  }
}
.CardPerson_box_card__0PWH1 .CardPerson_card__OlqtF .CardPerson_box_frame__UMt6a .CardPerson_messages__WI6bR {
  position: absolute;
  font-family: "Beer money";
  font-weight: 400;
  font-size: 1rem;
  line-height: 1rem;
  background-color: #fff;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.3);
  border-radius: 15px;
  padding: 20px 30px;
  top: -40px;
  left: 40px;
  right: -40px;
  z-index: 5;
  transform: scale(0) translateY(100px);
  transition: all 0.2s ease-out;
}
@media (max-width: 840px) {
  .CardPerson_box_card__0PWH1 .CardPerson_card__OlqtF .CardPerson_box_frame__UMt6a .CardPerson_messages__WI6bR {
    display: none;
  }
}
.CardPerson_box_card__0PWH1 .CardPerson_card__OlqtF .CardPerson_box_frame__UMt6a .CardPerson_messages__WI6bR::after {
  position: absolute;
  content: "";
  display: block;
  width: 0;
  height: 0;
  border-top: 50px solid #fff;
  border-right: 30px solid transparent;
  transform: rotate(10deg);
  top: calc(100% - 5px);
  right: 15%;
}
.CardPerson_box_card__0PWH1 .CardPerson_card__OlqtF .CardPerson_job__0cAMj {
  margin: 0;
  text-align: center;
  margin-top: -4%;
}
@media (max-width: 420px) {
  .CardPerson_box_card__0PWH1 .CardPerson_card__OlqtF .CardPerson_job__0cAMj {
    font-size: 0.9rem !important;
  }
}
.CardPerson_box_card__0PWH1 .CardPerson_card__OlqtF:hover .CardPerson_messages__WI6bR {
  transform: scale(1) translateY(0);
}
@media (min-width: 840px) {
  .CardPerson_box_card__0PWH1 .CardPerson_card__OlqtF.CardPerson_left__qH5GC {
    padding-right: 50px;
  }
  .CardPerson_box_card__0PWH1 .CardPerson_card__OlqtF.CardPerson_left__qH5GC .CardPerson_decor__pekup {
    left: 100%;
  }
  .CardPerson_box_card__0PWH1 .CardPerson_card__OlqtF.CardPerson_right__M2y\\+r {
    padding-left: 50px;
  }
  .CardPerson_box_card__0PWH1 .CardPerson_card__OlqtF.CardPerson_right__M2y\\+r .CardPerson_decor__pekup {
    right: 100%;
  }
}
.CardPerson_box_card__0PWH1 .CardPerson_mob_messages__LG2nM {
  position: absolute;
  background-color: #fff;
  font-family: "Beer money";
  font-weight: 400;
  font-size: 1rem;
  line-height: 1rem;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.3);
  border-radius: 15px;
  padding: 20px 30px;
  width: 45%;
  max-width: 280px;
  top: -10%;
  z-index: 6;
}
@media (min-width: 840px) {
  .CardPerson_box_card__0PWH1 .CardPerson_mob_messages__LG2nM {
    display: none;
  }
}
@media (max-width: 480px) {
  .CardPerson_box_card__0PWH1 .CardPerson_mob_messages__LG2nM {
    padding: 10px 15px;
  }
}
.CardPerson_box_card__0PWH1 .CardPerson_mob_messages__LG2nM::after {
  position: absolute;
  content: "";
  display: block;
  width: 0;
  height: 0;
  border-top: 40px solid #fff;
  border-right: 30px solid transparent;
  transform: rotate(10deg);
  top: calc(100% - 5px);
}

@media (max-width: 840px) {
  .CardPerson_box_card__0PWH1:nth-child(odd) .CardPerson_card__OlqtF {
    margin-inline: 10px auto;
  }
  .CardPerson_box_card__0PWH1:nth-child(odd) .CardPerson_card__OlqtF .CardPerson_decor__pekup {
    right: 100%;
  }
  .CardPerson_box_card__0PWH1:nth-child(odd) .CardPerson_card__OlqtF .CardPerson_inst__fjNzT {
    right: 1% !important;
    left: auto !important;
  }
}
@media (max-width: 840px) and (max-width: 480px) {
  .CardPerson_box_card__0PWH1:nth-child(odd) .CardPerson_card__OlqtF .CardPerson_inst__fjNzT {
    right: -2% !important;
  }
}
@media (max-width: 840px) {
  .CardPerson_box_card__0PWH1:nth-child(odd) .CardPerson_mob_messages__LG2nM {
    right: -15px;
  }
  .CardPerson_box_card__0PWH1:nth-child(odd) .CardPerson_mob_messages__LG2nM::after {
    transform: rotate(10deg);
    left: 15%;
  }
  .CardPerson_box_card__0PWH1:nth-child(even) .CardPerson_card__OlqtF {
    margin-inline: auto 10px;
  }
  .CardPerson_box_card__0PWH1:nth-child(even) .CardPerson_card__OlqtF .CardPerson_decor__pekup {
    left: 100%;
  }
  .CardPerson_box_card__0PWH1:nth-child(even) .CardPerson_card__OlqtF .CardPerson_inst__fjNzT {
    left: 1% !important;
    right: auto !important;
  }
}
@media (max-width: 840px) and (max-width: 480px) {
  .CardPerson_box_card__0PWH1:nth-child(even) .CardPerson_card__OlqtF .CardPerson_inst__fjNzT {
    left: -2% !important;
  }
}
@media (max-width: 840px) {
  .CardPerson_box_card__0PWH1:nth-child(even) .CardPerson_mob_messages__LG2nM {
    left: -15px;
  }
  .CardPerson_box_card__0PWH1:nth-child(even) .CardPerson_mob_messages__LG2nM::after {
    transform: rotate(10deg) scaleX(-1);
    right: 15%;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/CardPerson/CardPerson.module.scss"],"names":[],"mappings":"AAAA;EACG,kBAAA;EAEA,iBAAA;EACA,YAAA;EACA,gBAAA;EACA,aAAA;EACA,uBAAA;AAAH;AAEG;EATH;IAUM,eAAA;EACJ;AACF;AACG;EACG,sBAAA;EACA,gBAAA;AACN;AACM;EAJH;IAKM,WAAA;IACA,cAAA;EAEP;AACF;AACM;EACG,kBAAA;AACT;AACS;EACG,kBAAA;EACA,oBAAA;AACZ;AACY;EAJH;IAKM,WAAA;EAEb;AACF;AAAY;EARH;IASM,WAAA;EAGb;AACF;AADY;EAZH;IAaM,WAAA;EAIb;AACF;AADS;EACG,WAAA;EACA,kBAAA;EACA,UAAA;AAGZ;AAAS;EACG,kBAAA;EACA,QAAA;EACA,aAAA;EACA,uBAAA;EACA,uBAAA;AAEZ;AAAY;EACG,UAAA;EACA,WAAA;EACA,gBAAA;EAEA,iBAAA;EACA,uBAAA;EACA,UAAA;AACf;AAGS;EACG,SAAA;EACA,kBAAA;EACA,YAAA;EACA,yBAAA;EACA,gBAAA;EACA,UAAA;EACA,iBAAA;EACA,eAAA;EACA,iBAAA;EACA,mBAAA;EACA,UAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;AADZ;AAGY;EAjBH;IAkBM,WAAA;IACA,iBAAA;IACA,mBAAA;EAAb;AACF;AAGS;EACG,kBAAA;EACA,QAAA;EACA,QAAA;EACA,UAAA;AADZ;AAGY;EANH;IAOM,QAAA;IACA,qBAAA;EAAb;AACF;AAEY;EAXH;IAYM,mBAAA;EACb;AACF;AAES;EACG,kBAAA;EACA,yBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,sBAAA;EACA,uCAAA;EACA,mBAAA;EACA,kBAAA;EACA,UAAA;EACA,UAAA;EACA,YAAA;EACA,UAAA;EACA,qCAAA;EACA,6BAAA;AAAZ;AAEY;EAjBH;IAkBM,aAAA;EACb;AACF;AAES;EACG,kBAAA;EACA,WAAA;EACA,cAAA;EACA,QAAA;EACA,SAAA;EACA,2BAAA;EACA,oCAAA;EACA,wBAAA;EACA,qBAAA;EACA,UAAA;AAAZ;AAIM;EACG,SAAA;EACA,kBAAA;EACA,eAAA;AAFT;AAIS;EALH;IAMM,4BAAA;EADV;AACF;AAMM;EACG,iCAAA;AAJT;AAQG;EACG;IACG,mBAAA;EANP;EAQO;IACG,UAAA;EANV;EAUI;IACG,kBAAA;EARP;EAUO;IACG,WAAA;EARV;AACF;AAYG;EACG,kBAAA;EACA,sBAAA;EACA,yBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,uCAAA;EACA,mBAAA;EACA,kBAAA;EACA,UAAA;EACA,gBAAA;EACA,SAAA;EACA,UAAA;AAVN;AAaM;EAhBH;IAiBM,aAAA;EAVP;AACF;AAYM;EApBH;IAqBM,kBAAA;EATP;AACF;AAWM;EACG,kBAAA;EACA,WAAA;EACA,cAAA;EACA,QAAA;EACA,SAAA;EACA,2BAAA;EACA,oCAAA;EACA,wBAAA;EACA,qBAAA;AATT;;AAgBA;EAEM;IACG,wBAAA;EAdP;EAgBO;IACG,WAAA;EAdV;EAiBO;IACG,oBAAA;IACA,qBAAA;EAfV;AACF;AAgBY;EAJH;IAKM,qBAAA;EAbb;AACF;AAFA;EAkBM;IACG,YAAA;EAbP;EAcO;IACG,wBAAA;IACA,SAAA;EAZV;EAkBI;IACG,wBAAA;EAhBP;EAkBO;IACG,UAAA;EAhBV;EAmBO;IACG,mBAAA;IACA,sBAAA;EAjBV;AACF;AAkBY;EAJH;IAKM,oBAAA;EAfb;AACF;AA1BA;EA6CM;IACG,WAAA;EAhBP;EAiBO;IACG,mCAAA;IACA,UAAA;EAfV;AACF","sourcesContent":[".box_card {\r\n   position: relative;\r\n   // width: 100%;\r\n   flex-basis: 350px;\r\n   flex-grow: 1;\r\n   min-width: 360px;\r\n   display: flex;\r\n   justify-content: center;\r\n\r\n   @media (max-width: 840px) {\r\n      min-width: auto;\r\n   }\r\n\r\n   .card {\r\n      box-sizing: border-box;\r\n      max-width: 360px;\r\n\r\n      @media (max-width: 840px) {\r\n         width: 100%;\r\n         max-width: 60%;\r\n         // margin: 0 auto;\r\n      }\r\n\r\n      .box_frame {\r\n         position: relative;\r\n\r\n         .decor {\r\n            position: absolute;\r\n            margin-inline: -10px;\r\n\r\n            @media (max-width: 560px) {\r\n               width: 70px;\r\n            }\r\n\r\n            @media (max-width: 470px) {\r\n               width: 60px;\r\n            }\r\n\r\n            @media (max-width: 390px) {\r\n               width: 50px;\r\n            }\r\n         }\r\n\r\n         .frame {\r\n            width: 100%;\r\n            position: relative;\r\n            z-index: 2;\r\n         }\r\n\r\n         .box_foto {\r\n            position: absolute;\r\n            inset: 0;\r\n            display: flex;\r\n            align-items: flex-start;\r\n            justify-content: center;\r\n\r\n            .foto {\r\n               width: 85%;\r\n               height: 80%;\r\n               padding-top: 10%;\r\n\r\n               object-fit: cover;\r\n               object-position: center;\r\n               z-index: 1;\r\n            }\r\n         }\r\n\r\n         .name {\r\n            margin: 0;\r\n            position: absolute;\r\n            bottom: 10px;\r\n            font-family: \"Beer money\";\r\n            font-weight: 400;\r\n            width: 85%;\r\n            margin-bottom: 5%;\r\n            min-height: 17%;\r\n            font-size: 1.5rem;\r\n            line-height: 1.5rem;\r\n            z-index: 3;\r\n            display: flex;\r\n            align-items: center;\r\n            justify-content: center;\r\n            text-align: center;\r\n\r\n            @media (max-width: 420px) {\r\n               bottom: 5px;\r\n               font-size: 1.3rem;\r\n               line-height: 1.3rem;\r\n            }\r\n         }\r\n\r\n         .inst {\r\n            position: absolute;\r\n            top: 65%;\r\n            right: 0;\r\n            z-index: 4;\r\n\r\n            @media (max-width: 620px) {\r\n               top: 60%;\r\n               transform: scale(1.2);\r\n            }\r\n\r\n            @media (max-width: 480px) {\r\n               transform: scale(1);\r\n            }\r\n         }\r\n\r\n         .messages {\r\n            position: absolute;\r\n            font-family: \"Beer money\";\r\n            font-weight: 400;\r\n            font-size: 1rem;\r\n            line-height: 1rem;\r\n            background-color: #fff;\r\n            box-shadow: 0 0 10px rgba(0, 0, 0, 0.3);\r\n            border-radius: 15px;\r\n            padding: 20px 30px;\r\n            top: -40px;\r\n            left: 40px;\r\n            right: -40px;\r\n            z-index: 5;\r\n            transform: scale(0) translateY(100px);\r\n            transition: all 0.2s ease-out;\r\n\r\n            @media (max-width: 840px) {\r\n               display: none;\r\n            }\r\n         }\r\n\r\n         .messages::after {\r\n            position: absolute;\r\n            content: \"\";\r\n            display: block;\r\n            width: 0;\r\n            height: 0;\r\n            border-top: 50px solid #fff;\r\n            border-right: 30px solid transparent;\r\n            transform: rotate(10deg);\r\n            top: calc(100% - 5px);\r\n            right: 15%;\r\n         }\r\n      }\r\n\r\n      .job {\r\n         margin: 0;\r\n         text-align: center;\r\n         margin-top: -4%;\r\n\r\n         @media (max-width: 420px) {\r\n            font-size: 0.9rem !important;\r\n         }\r\n      }\r\n   }\r\n\r\n   .card:hover {\r\n      .messages {\r\n         transform: scale(1) translateY(0);\r\n      }\r\n   }\r\n\r\n   @media (min-width: 840px) {\r\n      .card.left {\r\n         padding-right: 50px;\r\n   \r\n         .decor {\r\n            left: 100%;\r\n         }\r\n      }\r\n   \r\n      .card.right {\r\n         padding-left: 50px;\r\n   \r\n         .decor {\r\n            right: 100%;\r\n         }\r\n      }\r\n   } \r\n\r\n   .mob_messages{\r\n      position: absolute;\r\n      background-color: #fff;\r\n      font-family: \"Beer money\";\r\n      font-weight: 400;\r\n      font-size: 1rem;\r\n      line-height: 1rem;\r\n      box-shadow: 0 0 10px rgba(0, 0, 0, 0.3);\r\n      border-radius: 15px;\r\n      padding: 20px 30px;\r\n      width: 45%;\r\n      max-width: 280px;\r\n      top: -10%;\r\n      z-index: 6;\r\n      \r\n\r\n      @media (min-width: 840px) {\r\n         display: none;\r\n      }\r\n\r\n      @media (max-width: 480px) {\r\n         padding: 10px 15px;\r\n      }\r\n\r\n      &::after {\r\n         position: absolute;\r\n         content: \"\";\r\n         display: block;\r\n         width: 0;\r\n         height: 0;\r\n         border-top: 40px solid #fff;\r\n         border-right: 30px solid transparent;\r\n         transform: rotate(10deg);\r\n         top: calc(100% - 5px);\r\n      }\r\n   }\r\n  \r\n}\r\n\r\n\r\n@media (max-width: 840px) {\r\n   .box_card:nth-child(odd) {\r\n      .card {\r\n         margin-inline: 10px auto;\r\n\r\n         .decor {\r\n            right: 100%;\r\n         }\r\n\r\n         .inst {\r\n            right: 1% !important;\r\n            left: auto !important;\r\n\r\n            @media (max-width: 480px) {\r\n               right: -2% !important;\r\n            }\r\n         }\r\n      }\r\n      .mob_messages{\r\n         right: -15px;\r\n         &::after{\r\n            transform: rotate(10deg);\r\n            left: 15%;\r\n         }\r\n      }\r\n   }\r\n\r\n   .box_card:nth-child(even) {\r\n      .card {\r\n         margin-inline: auto 10px;\r\n\r\n         .decor {\r\n            left: 100%;\r\n         }\r\n\r\n         .inst {\r\n            left: 1% !important;\r\n            right: auto !important;\r\n\r\n            @media (max-width: 480px) {\r\n               left: -2% !important;\r\n            }\r\n         }\r\n      }\r\n\r\n      .mob_messages{\r\n         left: -15px;\r\n         &::after{\r\n            transform: rotate(10deg) scaleX(-1);\r\n            right: 15%;\r\n         }\r\n      }\r\n   }\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"box_card": `CardPerson_box_card__0PWH1`,
	"card": `CardPerson_card__OlqtF`,
	"box_frame": `CardPerson_box_frame__UMt6a`,
	"decor": `CardPerson_decor__pekup`,
	"frame": `CardPerson_frame__ac11w`,
	"box_foto": `CardPerson_box_foto__v-4GQ`,
	"foto": `CardPerson_foto__t51R7`,
	"name": `CardPerson_name__7pvhP`,
	"inst": `CardPerson_inst__fjNzT`,
	"messages": `CardPerson_messages__WI6bR`,
	"job": `CardPerson_job__0cAMj`,
	"left": `CardPerson_left__qH5GC`,
	"right": `CardPerson_right__M2y+r`,
	"mob_messages": `CardPerson_mob_messages__LG2nM`
};
export default ___CSS_LOADER_EXPORT___;
